import React from "react";
import {Routes} from "ubcommunity-shared/src/constants/routes";
import AuthPage from "../AuthPage/AuthPage";
import {RequestResetPasswordForm} from "./RequestResetPasswordForm";
import {BackButton} from "../../Layout/BackButton/BackButton";
import {LoginHeader} from "../../Layout/Header/LoginHeader";
import {usePageTitle} from "ubcommunity-shared/src/Hooks/usePageTitle";
import {PageTitles} from "ubcommunity-shared/src/constants";

export function RequestResetPassword() {
    usePageTitle(PageTitles.REQUEST_PASSWORD_RESET);

    return (
        <AuthPage
            title={<LoginHeader title="Back" />}
            headerLeftButton={<BackButton to={Routes.LOGIN} />}
        >
            <RequestResetPasswordForm />
        </AuthPage>
    );
}
